import React from "react";
import { Select } from "antd";

const ACTIVITY_TYPES = ["HCPCS", "CPT", "Dental", "Service"] as const;
export type ActivityType = typeof ACTIVITY_TYPES[number];

export const ACTIVITY_TYPE_TO_CODE: Record<ActivityType, number> = {
  CPT: 3,
  HCPCS: 4,
  Dental: 6,
  Service: 8,
};

export const CODE_TO_ACTIVITY_TYPE: Record<string, ActivityType> = {
  "3": "CPT",
  "4": "HCPCS",
  "6": "Dental",
  "8": "Service",
};

interface ActivityTypeSingleSelectorProps {
  value?: ActivityType;
  onChange?: (value: ActivityType | undefined) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const OPTIONS = ACTIVITY_TYPES.map((type) => ({
  label: type === "Dental" ? "Dental" : type,
  value: type,
}));

const ActivityTypeSingleSelector: React.FC<ActivityTypeSingleSelectorProps> = ({
  value,
  onChange,
  placeholder = "Select Activity Type",
  style,
  disabled = false,
}) => {
  return (
    <Select<ActivityType>
      data-testid="ActivityTypeSingleSelector-select"
      value={value}
      options={OPTIONS}
      placeholder={placeholder}
      disabled={disabled}
      allowClear
      style={{ width: "100%", marginBottom: 5, ...style }}
      getPopupContainer={(trigger) => trigger.parentElement!}
      onChange={(val) => onChange?.(val)}
    />
  );
};

export default ActivityTypeSingleSelector;